import React, { useState } from "react";

const ApplicationType = ({ data, update, next, prev }) => {
  const [form, setForm] = useState(data.application || {});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleNext = () => {
    update("application", form);
    next();
  };

  const isValid = form.type && form.declaration;

  return (
    <div>

      <h3 className="text-lg font-semibold mb-4">
        Application Type
      </h3>

      {/* Application Type */}
      <div className="grid grid-cols-3 gap-4">

        <label className="border rounded-lg p-4 cursor-pointer hover:border-blue-500">
          <div className="flex items-center gap-2">
            <input
              type="radio"
              name="type"
              value="Normal"
              checked={form.type === "Normal"}
              onChange={handleChange}
            />
            <span className="font-medium">Normal</span>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Standard processing time
          </p>
        </label>

        <label className="border rounded-lg p-4 cursor-pointer hover:border-blue-500">
          <div className="flex items-center gap-2">
            <input
              type="radio"
              name="type"
              value="Tatkal"
              checked={form.type === "Tatkal"}
              onChange={handleChange}
            />
            <span className="font-medium">Tatkal</span>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Fast processing (extra fee)
          </p>
        </label>

        <label className="border rounded-lg p-4 cursor-pointer hover:border-blue-500">
          <div className="flex items-center gap-2">
            <input
              type="radio"
              name="type"
              value="Renewal"
              checked={form.type === "Renewal"}
              onChange={handleChange}
            />
            <span className="font-medium">Renewal</span>
          </div>
          <p className="text-sm text-gray-500 mt-1">
            Renew existing application
          </p>
        </label>

      </div>

      {/* Declaration */}
      <div className="mt-6 p-4 border rounded-lg bg-gray-50">

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            name="declaration"
            checked={form.declaration || false}
            onChange={handleChange}
            className="mt-1"
          />

          <span className="text-sm">
            I hereby declare that all the information provided is true and correct 
            to the best of my knowledge. I understand that any false information 
            may lead to rejection of my application.
          </span>

        </label>

      </div>

      {/* Buttons */}
      <div className="mt-6 flex justify-between">

        <button
          onClick={prev}
          className="btn-secondary"
        >
          Back
        </button>

        <button
          disabled={!isValid}
          onClick={handleNext}
          className={`btn-primary ${!isValid ? "opacity-50 cursor-not-allowed" : ""}`}
        >
          Next
        </button>

      </div>

    </div>
  );
};

export default ApplicationType;